import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ChatbotLinkBiData } from '../types';
import { getKbWidgetState, getRuntimeDataForBi } from '../utils';

export const logWixContactClickOnTheActionButton: BiEventLogger<ChatbotLinkBiData> = async (
  state,
  { link },
) => {
  const biData = selectBiData(state);
  const { sessionId, contextBi } = await getRuntimeDataForBi(state);

  biLogger.wixContactClickOnTheActionButton({
    action_url: link,
    kb_widget_state: getKbWidgetState(state),
    lang: locale,
    session_id: sessionId,
    main_option_name: biData.mainOptionName,
    user_experience: contextBi?.user_experience,
    widget_view_mode: undefined,
    main_option_id: undefined,
    sub_option_id: undefined,
    call_center_status: undefined,
    estimated_wait_time: undefined,
    referral_name: undefined,
    solution_time: undefined,
    solution_title: undefined,
    sub_option_name: undefined,
    ticketing_status: undefined,
    chatbot_view: undefined,
    suggestion_id: undefined,
    chatbot_state: undefined,
  });
};
